import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import { selectLoanApplication } from './loanApplication.selectors';

const selectLoanFeeReasonHistory = createSelector(
  selectLoanApplication,
  ({ loanFeeReasonHistory }) => loanFeeReasonHistory || {},
);

export const selectLoanFeeReasonHistoryByFeeTypeId = memoizeOne(feeTypeId =>
  createSelector(selectLoanFeeReasonHistory, cicChangeDetails => cicChangeDetails[feeTypeId] ?? []),
);

export const selectIsCICHistoryReasonExists = memoizeOne(feeTypeId =>
  createSelector(
    selectLoanFeeReasonHistory,
    cicChangeDetails => !!(cicChangeDetails[feeTypeId] ?? []).length,
  ),
);
